// extracted by mini-css-extract-plugin
export default {"area-action-header":"areaActionHeader_area-action-header__R8w1b","color":"areaActionHeader_color__k3L9q"};